const LessonCompletedNotice = () => (
  <p className='bg-muted p-4 text-center text-muted-foreground rounded-lg mx-3 mb-3 leading-none'>
    You have completed this lesson
  </p>
)

export default LessonCompletedNotice
